import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import {
  addError,
  clearUsers,
  resendEmail,
  sendEmail,
  signUp,
  deleteUser,
  upgradeRank,
  downgradeRank,
  updateUser,
} from './actions';
import api from '../../services/api';

function generateQueryString(params) {
  const query = new URLSearchParams();

  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      query.append(key, params[key]);
    }
  }

  return `?${query.toString()}`;
}

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ page, queries = {} }, { rejectWithValue }) => {
    const { filters } = queries;
    try {
      const query = generateQueryString(filters);
      const route = '/users/pagination/' + page + '/' + query;
      const response = await api.get(route);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const usersReducer = createReducer(
  { pagination: [], status: 'idle', pages: 1 },
  {
    [fetchUsers.pending]: (state, action) => {
      state.status = 'loading';
    },
    [fetchUsers.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.pagination = action.payload.users; //passando o users para estado
      state.pages = action.payload.pages; //passando o pages para
    },

    /**
     * ? deleteUser
     * * Deleta funcionário X da lista de funcionários do gerente (EmployeeModal)
     */
    [deleteUser]: (state, action) => {},

    /**
     * ? upgradeUser
     * * Atualiza um usuario de colaborador para gerente
     */
    [upgradeRank]: (state, action) => {
      const userId = action.payload.user._id;

      state.pagination = state.pagination.map((user) =>
        user._id === userId ? { ...user, rank: 'gerente' } : user
      );
    },

    /**
     * ? downgradeUser
     * * Atualiza um usuario de gerente para colaborador
     */
    [downgradeRank]: (state, action) => {
      const userId = action.payload.user._id;

      state.pagination = state.pagination.map((user) =>
        user._id === userId ? { ...user, rank: 'colaborador' } : user
      );
    },

    /**
     * ? addError
     * * Mensagem de erro associado ao usuário enviado pelo banco
     */
    [addError]: (state, action) => {
      state.errorMessage = action.payload;
    },

    /**
     * ? clearUsers
     * * Limpando conta de usuário do estado local
     */
    [clearUsers]: (state) => {
      state.status = 'idle';
      state.users = [];
      state.pages = 1;
    },
    [updateUser]: (state, action) => {},

    /**
     * ? signUp
     * * Criação de conta de funcionário dentro da conta de gerente
     */
    [signUp]: (state, action) => {},
    [sendEmail]: (state, action) => {},
    [resendEmail]: (state) => {},
  }
);

export default usersReducer;
